// extracted by mini-css-extract-plugin
export default {"toggleButton":"ToggleButton_toggleButton__oc65Q","active":"ToggleButton_active__HTLwD","toggleBall":"ToggleButton_toggleBall__3vZmo","disabled":"ToggleButton_disabled__i2AY3"};